import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/utils/rem'

import 'element-ui/lib/theme-chalk/index.css'
import elementUI from 'element-ui'
Vue.use(elementUI, { /*size: 'mini'*/ })

// fragment 标签不会被渲染
import Fragment from 'vue-fragment'
Vue.use(Fragment.Plugin)

import waterfall from 'vue-waterfall2'
Vue.use(waterfall)

Vue.prototype.$bus = new Vue()
Vue.prototype.$appData = {
  childData: null
}

Vue.config.productionTip = false

// 全局方法挂载
import { parseTime, resetForm, addDateRange, selectDictLabel, selectDictLabels, handleTree } from "@/utils/ruoyi"
Vue.prototype.parseTime = parseTime
Vue.prototype.resetForm = resetForm
Vue.prototype.addDateRange = addDateRange
Vue.prototype.selectDictLabel = selectDictLabel
Vue.prototype.selectDictLabels = selectDictLabels
Vue.prototype.handleTree = handleTree


new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
